import * as _ from 'lodash';
import { analysticsConstant } from '../constants/analysticsConstant';
import {trackOrderEvent} from '../services/analytics-util';
import ApprovalService from "../services/ApprovalService";


export const createNewOrdersAnalyticsLog = (selectedApproval) => {
    let orderResponse = _.has(selectedApproval, 'callBackDetails.requestBody.requestBody') ? selectedApproval.callBackDetails.requestBody.requestBody : '';
    
    if(_.has(selectedApproval, 'callBackDetails.requestBody.apiDetails.commerce-order-v4-place-order.requestBody')){
      orderResponse = selectedApproval.callBackDetails.requestBody.apiDetails['commerce-order-v4-place-order'].requestBody;
    }
    
    const otherAnalyticsData  = _.has(selectedApproval, 'approvalMetaData.analyticsLogOtherDetails') ? selectedApproval.approvalMetaData.analyticsLogOtherDetails: '';
  
  
    const agentObj = _.has(orderResponse, 'agent-info') ? orderResponse['agent-info'] : '';
  

    var analysticsObj = {
      pageName: analysticsConstant.CUSTOMER_APPORVAL_PORTAL,
      action: analysticsConstant.PURCHASE,
      flowType: otherAnalyticsData.flowType,
      flowSubType:otherAnalyticsData.flowSubType,
      requestType: analysticsConstant.EVENT,
    };


    _.has(agentObj,'agent-id') && (analysticsObj.agentLdap = agentObj['agent-id']);
    _.has(orderResponse, 'order-identity.owner-id') && (analysticsObj.customerGuid = orderResponse['order-identity']['owner-id']);
    _.has(orderResponse, 'order-identity.identity-email') && (analysticsObj.customerEmail = orderResponse['order-identity']['identity-email']);
    _.has(orderResponse, 'country') && (analysticsObj.customerCountryCode = orderResponse.country);
    _.has(orderResponse, 'order-price.total-with-tax') && (analysticsObj.totalValue = orderResponse['order-price']['total-with-tax']);
    _.has(orderResponse, 'currency') && (analysticsObj.currencyCode = orderResponse.currency);
    _.has(otherAnalyticsData, 'products') && (analysticsObj.products = otherAnalyticsData.products);
    _.has(orderResponse, 'order-number') && (analysticsObj.purchaseID = orderResponse['order-number']);

    if(_.has(orderResponse, 'type') && orderResponse.type === 'QUOTE'){
      analysticsObj.orderCategory = 'QUOTE'
    }
    else {
      analysticsObj.orderCategory = 'ORDER'
    }

    _.has(otherAnalyticsData, 'orderType') && (analysticsObj.orderType = otherAnalyticsData.orderType);
    (_.has(orderResponse, 'type') && (orderResponse.type !== 'QUOTE')) && (analysticsObj.internalOrderType = orderResponse.type);
    _.has(otherAnalyticsData, 'paymentCategory') && (analysticsObj.paymentCategory = otherAnalyticsData.paymentCategory);
    (_.has(orderResponse, 'payment-instrument') && _.has(orderResponse, 'type') && orderResponse.type !== 'QUOTE') && (analysticsObj.paymentType = getPaymentType(orderResponse['payment-instrument']));
    (_.has(orderResponse, 'payment-instrument') && _.has(orderResponse, 'type') && orderResponse.type !== 'QUOTE') && (analysticsObj.paymentSubType = getPaymentSubType(orderResponse['payment-instrument']));
    _.has(otherAnalyticsData, 'paymentSource') && (analysticsObj.paymentSource = otherAnalyticsData.paymentSource);
    _.has(orderResponse, 'market-segment') && (analysticsObj.marketSegment = orderResponse['market-segment']);
    _.has(orderResponse, 'order-number') && (analysticsObj.orderNumber =  orderResponse['order-number']);

    if (analysticsObj.totalValue === 0) {
      analysticsObj.totalValue = _.has(orderResponse, 'order-price.total-without-tax')
        ? orderResponse['order-price']['total-without-tax']
        : 0;
    }
    _.has(otherAnalyticsData, 'offerType') && (analysticsObj.offerType = otherAnalyticsData.offerType);
    _.has(otherAnalyticsData, 'promoDiscountType') && (analysticsObj.promoDiscountType = otherAnalyticsData.promoDiscountType);
    _.has(otherAnalyticsData, 'arrTotalWithoutTax') && (analysticsObj.arrTotalWithoutTax = otherAnalyticsData.arrTotalWithoutTax);
    _.has(otherAnalyticsData, 'arrTotalWithTax') && (analysticsObj.arrTotalWithTax = otherAnalyticsData.arrTotalWithTax);
    _.has(otherAnalyticsData, 'agentChannel') && (analysticsObj.agentChannel = otherAnalyticsData.agentChannel);
    _.has(otherAnalyticsData, 'agentCallCenter') && (analysticsObj.agentCallCenter = otherAnalyticsData.agentCallCenter);
    _.has(otherAnalyticsData, 'agentPersona') && (analysticsObj.agentPersona = otherAnalyticsData.agentPersona);
    _.has(otherAnalyticsData, 'agentEmployeeType') && (analysticsObj.agentEmployeeType = otherAnalyticsData.agentEmployeeType);
    _.has(otherAnalyticsData, 'agentOrganization') && (analysticsObj.agentOrganization = otherAnalyticsData.agentOrganization);
    _.has(otherAnalyticsData, 'agentGeolocation') && (analysticsObj.agentGeolocation = otherAnalyticsData.agentGeolocation);

    _.has(otherAnalyticsData, 'agentSalesCenter') && (analysticsObj.agentSalesCenter = otherAnalyticsData.agentSalesCenter);
    _.has(otherAnalyticsData, 'agentSalesGeolocation') && (analysticsObj.agentSalesGeolocation = otherAnalyticsData.agentSalesGeolocation);
    _.has(otherAnalyticsData, 'agentRepName') && (analysticsObj.agentRepName = otherAnalyticsData.agentRepName);
    _.has(otherAnalyticsData, 'agentTsm') && (analysticsObj.agentTsm = otherAnalyticsData.agentTsm);
    _.has(otherAnalyticsData, 'agentTsmLdap') && (analysticsObj.agentTsmLdap = otherAnalyticsData.agentTsmLdap);
    _.has(otherAnalyticsData, 'agentManager') && (analysticsObj.agentManager = otherAnalyticsData.agentManager);
    _.has(otherAnalyticsData, 'agentManagerLdap') && (analysticsObj.agentManagerLdap = otherAnalyticsData.agentManagerLdap);
    _.has(otherAnalyticsData, 'agentFinalTeam') && (analysticsObj.agentFinalTeam = otherAnalyticsData.agentFinalTeam);
    _.has(otherAnalyticsData, 'agentActiveFlag') && (analysticsObj.agentActiveFlag = otherAnalyticsData.agentActiveFlag);
    _.has(otherAnalyticsData, 'agentShiftTime') && (analysticsObj.agentShiftTime = otherAnalyticsData.agentShiftTime);
    _.has(otherAnalyticsData, 'agentTimeZone') && (analysticsObj.agentTimeZone = otherAnalyticsData.agentTimeZone);
    _.has(otherAnalyticsData, 'agentTag') && (analysticsObj.agentTag = otherAnalyticsData.agentTag);
    _.has(otherAnalyticsData, 'supportAgentName') && (analysticsObj.supportAgentName = otherAnalyticsData.supportAgentName);
    _.has(otherAnalyticsData, 'supportAgentEmployeeType') && (analysticsObj.supportAgentEmployeeType = otherAnalyticsData.supportAgentEmployeeType);
    _.has(otherAnalyticsData, 'supportAgentEEBusinessUnit') && (analysticsObj.supportAgentEEBusinessUnit = otherAnalyticsData.supportAgentEEBusinessUnit);
    _.has(otherAnalyticsData, 'supportAgentActiveStatus') && (analysticsObj.supportAgentActiveStatus = otherAnalyticsData.supportAgentActiveStatus);
    _.has(otherAnalyticsData, 'customerRegion') && (analysticsObj.customerRegion = otherAnalyticsData.customerRegion);
    _.has(otherAnalyticsData, 'agentProfileChannel') && (analysticsObj.agentProfileChannel = otherAnalyticsData.agentProfileChannel);

    _.has(otherAnalyticsData, 'multiContractOrgId') && (analysticsObj.multiContractOrgId = otherAnalyticsData.multiContractOrgId);
    _.has(otherAnalyticsData, 'multiContractPlan') && (analysticsObj.multiContractPlan = otherAnalyticsData.multiContractPlan);

    if(_.has(orderResponse, 'market-segment') && orderResponse['market-segment'] === 'EDU'){
      if(_.has(selectedApproval, 'callBackDetails.requestBody.apiDetails.ecommerce-education-validation.requestBody')){
        const eduRequestBody = selectedApproval.callBackDetails.requestBody.apiDetails['ecommerce-education-validation'].requestBody;
        analysticsObj.eduUserType = eduRequestBody['user-type'];
      }
    }
    // _.has(otherAnalyticsData, 'ARROrderTotalWithoutTax') && (analysticsObj.ARROrderTotalWithoutTax = otherAnalyticsData.ARROrderTotalWithoutTax);
    // _.has(otherAnalyticsData, 'ARROrderTotalWithTax') && (analysticsObj.ARROrderTotalWithTax = otherAnalyticsData.ARROrderTotalWithTax);
    _.has(otherAnalyticsData, 'ctaId') && (analysticsObj.ctaId = otherAnalyticsData.ctaId);
    _.has(otherAnalyticsData, 'campaignName') && (analysticsObj.campaignName = otherAnalyticsData.campaignName);
    if (analysticsObj.currencyCode === 'USD') {
      analysticsObj.ARROrderTotalWithoutTax = otherAnalyticsData.arrTotalWithoutTax;
      analysticsObj.ARROrderTotalWithTax = otherAnalyticsData.arrTotalWithTax;
      trackOrderEvent(analysticsObj);
    } else {
      if (otherAnalyticsData.arrTotalWithoutTax || otherAnalyticsData.arrTotalWithTax) {
        if (otherAnalyticsData.arrTotalWithoutTax) {
          ApprovalService.getCurrencyConversionConfig(analysticsObj.currencyCode, otherAnalyticsData.arrTotalWithoutTax).then(
            function (resp) {
              analysticsObj.ARROrderTotalWithoutTax = resp && resp.data.valueInUSD ? resp.data.valueInUSD.toFixed(2) : '';
              if (analysticsObj.totalValue) {
                ApprovalService.getCurrencyConversionConfig(analysticsObj.currencyCode, otherAnalyticsData.arrTotalWithTax).then(
                  function (resp) {
                    analysticsObj.ARROrderTotalWithTax = resp && resp.data.valueInUSD ? resp.data.valueInUSD.toFixed(2) : '';
                    trackOrderEvent(analysticsObj);
                  },
                  function () {
                    trackOrderEvent(analysticsObj);
                  }
                );
              }
            },
            function () {
              trackOrderEvent(analysticsObj);
            }
          );
        } else if (otherAnalyticsData.arrTotalWithTax) {
          ApprovalService.getCurrencyConversionConfig(analysticsObj.currencyCode, otherAnalyticsData.arrTotalWithTax).then(
            function (resp) {
              analysticsObj.ARROrderTotalWithTax = resp && resp.data.valueInUSD ? resp.data.valueInUSD.toFixed(2) : '';
              trackOrderEvent(analysticsObj);
            },
            function () {
              trackOrderEvent(analysticsObj);
            }
          );
        }
      }
    }

    // trackOrderEvent(analysticsObj);
  }

export const getPaymentSubType = (paymentObj) => {
  if (!paymentObj || typeof paymentObj !== "object") {
    return "";
  }
  for (const property of analysticsConstant.PAYMENT_SUBTYPE_PRIORITY) {
    if (_.has(paymentObj, property) && paymentObj[property]) {
      return paymentObj[property];
    }
  }
  return "";
};
  
export const getPaymentType = (paymentObj) => {
  let paymentType = '';
  const category = _.has(paymentObj, 'category') ? paymentObj.category : '';
  const offlineType = _.has(paymentObj, 'offline-type') ? paymentObj['offline-type'] : '';

  switch (category) {
    case 'CREDIT_CARD':
      paymentType = 'CREDIT_CARD';
      break;
    case 'DIRECT_DEBIT':
      paymentType = 'DIRECT_DEBIT';
      break;
    case 'OFFLINE':
      if (offlineType === 'BANK_TRANSFER') {
        paymentType = 'BANK_TRANSFER';
      } else if (offlineType === 'BOLETO') {
        paymentType = 'BOLETO';
      } else if (offlineType === 'CVS') {
        paymentType = 'CVS';
      }
      break;
    case 'PURCHASE_ORDER':
      paymentType = 'PURCHASE_ORDER';
      break;
    case 'PAYPAL':
      paymentType = 'PAYPAL';
      break;
    case 'LPM':
      paymentType = 'LPM';
      break;
    case 'EXTERNAL_WALLET':
      paymentType = 'EXTERNAL_WALLET';
      break;
    default:
      break;
  }
  return paymentType;
};

export const extractDetails = (approvedData,key) => {
  if (!approvedData || !approvedData.callBackDetails) {
    return null;
  }

  // Try the primary path first
  if (_.has(approvedData, "callBackDetails.requestBody.requestBody.id")) {
    return approvedData.callBackDetails.requestBody.requestBody[key];
  }

  // Try commerce-order-v4-place-order path
  if (
    _.has(
      approvedData,
      "callBackDetails.requestBody.apiDetails.commerce-order-v4-place-order.requestBody.id"
    )
  ) {
    return approvedData.callBackDetails.requestBody.apiDetails[
      "commerce-order-v4-place-order"
    ].requestBody[key];
  }

  return null;
};